/**
 * useDocumentTraining — eDMS E5 (training ↔ document, reverse link).
 *
 * GET /api/v1/documents/{id}/training → the read-training rollup for the
 * document: who must be trained on the current version, who's done, who's
 * overdue. Served by the mock-api via the prod-proxy 404-fallback.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '../../api/client';

export interface TrainingRosterEntry {
  user_name: string;
  role: string;
  state: 'COMPLETED' | 'OVERDUE' | 'ASSIGNED';
  due_date: string;
  completed_at: string | null;
}
export interface DocumentTraining {
  document_id: string;
  summary: { total: number; completed: number; overdue: number; assigned: number; pct_complete: number };
  roster: TrainingRosterEntry[];
  /** B-2: true when the document isn't yet Effective, so no training is assigned. */
  gated?: boolean;
  gate_reason?: string;
  status?: string;
}

export function useDocumentTraining(documentId: string | undefined): UseQueryResult<DocumentTraining> {
  return useQuery<DocumentTraining>({
    queryKey: ['documents', documentId ?? '', 'training'],
    queryFn: () =>
      apiFetch<DocumentTraining>(`/api/v1/documents/${encodeURIComponent(documentId!)}/training`),
    enabled: !!documentId,
    staleTime: 30_000,
  });
}
